// eslint-disable-next-line no-shadow
export enum Currencies {
  // eslint-disable-next-line no-unused-vars
  USD = "USD",
  // eslint-disable-next-line no-unused-vars
  BRL = "BRL",
}
